import React from 'react';
import Loader from 'react-loader-spinner'


export default function Loading(props) {
    return (
        <div
            className="loading-container" key={0}
        >
            <Loader 
                type="Oval"
                color="#C62828"
                height="60"	
                width="60"
            /> 
        </div>
    );
}

export function LoadingInline(props) {
    return (
        <div
            className="loading-inline-container"
            key={0}
            style={{padding: `${props.padding || '20'}px 20px`}}
        >
            <Loader 
                type="Oval"
                color="#C62828"
                height="60"	
                width="60"
            />
        </div>
    )
}